export enum MessageStatus {
    Done = 'done',
    Closed = 'closed',
}
